import React from 'react';
import Router from '../../routes/router.jsx';
import './style.css';

const AppLayout = () => {

  return (
    <div className='relative h-screen overflow-x-hidden scrollbar-hide md:w-1/2 lg:w-1/3 m-auto'>
      <Router />
    </div>
  );
};

export default AppLayout;
